/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _store = require('./redux/store/store');

var _store2 = _interopRequireDefault(_store);

var _routes = require('./routes');

require('./style/global.less');

var _premissionAuth = require('./utils/premissionAuth');

var _reactFreeScrollbar = require('react-free-scrollbar');

var _reactFreeScrollbar2 = _interopRequireDefault(_reactFreeScrollbar);

var _config = require('util/config');

var _tool = require('util/tool');

var _mamSso = require('mam-sso');

var _mamSso2 = _interopRequireDefault(_mamSso);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { syncHistoryWithStore } from 'react-router-redux';
if (__DEV__) {
  console.log('现在是开发环境');
}

if (__PROD__) {
  console.log('现在是生产环境');
}

var initialState = {
  // user: Immutable.fromJS({token: window.localStorage.getItem("token") || null }),
  user: _immutable2.default.fromJS({ token: localStorage.getItem('token') || null, userName: null }),
  fetchData: _immutable2.default.fromJS({ data: {}, isFetching: false })
};
function getValue(name) {
  var arr = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < arr.length; i++) {
    var key = arr[i].split('=')[0];
    if (name == key) {
      return arr[i].split('=')[1];
    }
  }
}

var domin = window.location.href;
if (domin.includes('.mamobility.com')) {
  // 表示发布到服务器上去的访问
  if (domin.startsWith('https')) {
    // 表示是https访问
  } else {
    var url = domin.split('http')[1];
    window.location.href = 'https' + url;
  }
}

// if (window.location.protocol.includes('https') == 0) {
//     window.location.href = window.location.href.replace('http', 'https');
// }

/*if (getValue('token') != undefined && getValue('token') != '') {
  // 往cookies里面种token 当然也可以选择放到localStorage里面
  setToken(getValue('token'))

}*/

// console.log(getQueryString('token'),'我是token')
// if (getQueryString('token') !== undefined && getQueryString('token') !== '') {
//     const BASEURL = getQueryString('baseUrl')
//     setToken(getQueryString('token'))
//     let exec_obj = document.createElement('iframe')
//     exec_obj.name = 'tmp_frame'
//     exec_obj.src = `${BASEURL}?${Math.random()}`
//     exec_obj.style.display = 'none'
//     document.body.appendChild(exec_obj);
// }
_mamSso2.default.init(function (data) {
  (0, _premissionAuth.setToken)(data.data);
  localStorage.setItem('token', data.data);
  (0, _tool.http)(_config.apiJson.loginByToken, {}).then(function (res) {
    window.localStorage.setItem('userName', res.data.name);
  }).catch(function (err) {
    console.log(err);
  });
}, function (error) {
  console.error('单点登录出问题了~~: ', error);
});

var store = (0, _store2.default)(initialState);
var root = document.getElementById('app');

var history = process.env.NODE_ENV !== 'production' ? _reactRouter.browserHistory : _reactRouter.hashHistory;

// const history = syncHistoryWithStore( browserHistory, store );

(0, _reactDom.render)((0, _jsx3.default)('div', {
  style: { width: '100%', height: '100%' }
}, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {
  autohide: true,
  style: { width: '100%', height: '100%' }
}, void 0, (0, _jsx3.default)(_reactRedux.Provider, {
  store: store
}, void 0, (0, _jsx3.default)(_reactRouter.Router, {
  routes: _routes.RouterConfig,
  history: history
})))), root);

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/index.jsx
// module id = 0
// module chunks = 0